import React, { useEffect, useRef, useState } from "react";
import { useTimeSheetStore } from "../../../../config/stores";
import AntdModal from "../../../../components/common/AntdModal";
import AppButton from "../../../../components/common/AppButton";
import { filter } from "lodash";
import dayjs from "dayjs";
import AntdTable from "../../../../components/common/AntdTable";
import TableTitle from "../../../../components/common/TableTitle";
import TableButtonActions from "../../../../components/common/TableButtonActions";
import PrintDayTimeSheet from "../MangeMyTimeSheets/PrintDayTimeSheet";
import { useReactToPrint } from "react-to-print";
import { AiOutlineClose, AiOutlinePrinter } from "react-icons/ai";

const TimeSheetDayActivities = () => {
  const timeSheetStore = useTimeSheetStore();
  const [activities, setActivities] = useState();
  const [deleteId, setDeleteId] = useState(null);
  const { timeSheetActivitiesDate, showTimeSheetActivities, timeSheetDetails } =
    timeSheetStore;

  const closeModal = () => {
    timeSheetStore.setShowTimeSheetActivities();
  };

  useEffect(() => {
    if (timeSheetActivitiesDate) {
      const dayActivities = filter(
        timeSheetDetails.timeSheetActivities,
        (activity) => {
          const activityDay =
            activity.day_of_month ?? dayjs(activity.date).date();
          return activityDay === timeSheetActivitiesDate.day;
        }
      );

      setActivities(dayActivities);
    }
  }, [timeSheetActivitiesDate, timeSheetDetails.timeSheetActivities]);

  const updateRecord = (record) => {
    timeSheetStore.setAddingTimeSheetActivity(false, true, record);
  };
  const confirmDelete = () => {
    timeSheetStore.deleteTimeSheetActivity(deleteId, timeSheetDetails.id);
    setDeleteId(null);
  };

  const deleteRecord = (id) => setDeleteId(id);

  const columns = [
    {
      title: "PROJECTS",
      dataIndex: "project",
      render: (project, record) => (
        <span
          onClick={() =>
            timeSheetStore.setAddingTimeSheetActivity(false, true, record)
          }
          className="text-primary"
        >
          {project?.name || "SHARED"}
        </span>
      ),
    },
    {
      title: "ACTIVITY",
      dataIndex: "activity",
    },
    {
      title: "HOURS",
      dataIndex: "hours",
    },
    {
      title: "ACTIONS",
      key: "actions",
      responsive: ["md"],
      render: (record) => {
        return (
          <TableButtonActions
            record={record}
            confirmDelete={confirmDelete}
            deleteLoading={timeSheetStore.deletingTimeSheetActivity}
            updateRecord={updateRecord}
            deleteId={deleteId}
            deleteRecord={deleteRecord}
          />
        );
      },
    },
  ];

  const addActivity = () => {
    timeSheetStore.setAddingTimeSheetActivity(true, true, {});
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    contentRef: componentRef,
    documentTitle: `${timeSheetDetails?.user?.first_name || ""} ${
      timeSheetDetails?.user?.other_names || ""
    } ${timeSheetStore.timeSheetActivitiesDate.date} ACTIVITIES`,
  });
  const onPrint = () => {
    setTimeout(() => {
      handlePrint();
    }, 50);
  };
  return (
    <div>
      <AntdModal
        title={`${timeSheetStore.timeSheetActivitiesDate.date} ACTIVITIES`}
        visible={showTimeSheetActivities}
        closeModal={closeModal}
        size="large"
        footer={[
          <AppButton
            text="PRINT"
            key={"print"}
            onClick={onPrint}
            iconBefore={<AiOutlinePrinter />}
            loading={timeSheetStore.deletingTimeSheetActivity}
            type="primary"
          />,
          <AppButton
            text="CANCEL"
            key={"cancel"}
            iconBefore={<AiOutlineClose />}
            onClick={closeModal}
            danger
          />,
        ]}
      >
        <AntdTable
          title={() => (
            <TableTitle
              openAddModal={addActivity}
              refreshTable={null}
              search={null}
              exportRecords={null}
            />
          )}
          rowKey="id"
          pagination={false}
          pageSize={20}
          data={activities}
          columns={columns}
        />
        <div className="d-none">
          <div ref={componentRef}>
            <PrintDayTimeSheet dayActivities={activities} />
          </div>
        </div>
      </AntdModal>
    </div>
  );
};

export default TimeSheetDayActivities;
